import { render, staticRenderFns } from "./task-full-info-tag-option.vue?vue&type=template&id=54f81fae&scoped=true"
import script from "./task-full-info-tag-option.vue?vue&type=script&lang=js"
export * from "./task-full-info-tag-option.vue?vue&type=script&lang=js"
import style0 from "./task-full-info-tag-option.vue?vue&type=style&index=0&id=54f81fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f81fae",
  null
  
)

export default component.exports